function extractMetaAndParse(content) {
    const regex = new RegExp('---\\ntitle: (.*)\\ndescription: (.*)\\n---\\n([\\s\\S]*)$', 'g');
    const results = regex.exec(content);

    if (results === null) {
        return { body: parse(content) };
    }

    return {
        body: parse(results[3]),
        meta: {
            title: results[1],
            description: results[2],
        },
    };
}

function parse(content) {
    const regex = /<img.+?src=["'](.*?)["']/gi;

    let match;
    while (null != (match = regex.exec(content))) {
        const fullMatch = match[0];
        const src = match[1];

        const replacement = fullMatch.replace(src, require(`~/content/static/img/${src}`));
        content = content.replace(fullMatch, replacement);
    }

    return content;
}

export default function (path) {
    try {
        const filesystemSafePath = path.replace(/[^A-Za-z0-9]*/, '');
        return extractMetaAndParse(require(`~/content/static/${filesystemSafePath}.md`).default);
    } catch (e) {
        return null;
    }
}
